import { reactiveComputed } from "@vueuse/core";
import { computed, toRef } from "vue";

import type { Size } from "@/lib/components/types";

import { size } from "@/lib/components/logic/atoms/input/props";
import { propsDefinition } from "@/lib/composables/componentComposable";

type UseInputWrapperAtomScoped = {
  disabled?: boolean;
  showValidState?: boolean;
  size?: Size;
};

type UseInputWrapperAtomProps = UseInputWrapperAtomScoped & {
  color?: string;
  focused?: boolean;
  tag?: string;
  valid?: boolean;
};

const scoped = propsDefinition({
  disabled: { type: Boolean, default: false },
  showValidState: { type: Boolean, default: true },
  size,
}) satisfies Record<keyof UseInputWrapperAtomScoped, unknown>;

const props = propsDefinition({
  ...scoped,
  focused: { type: Boolean, default: false },
  valid: { type: Boolean, default: false },
  color: { type: String, required: false },
  tag: { type: String, default: "div" },
}) satisfies Record<keyof UseInputWrapperAtomProps, unknown>;

function use(props: UseInputWrapperAtomProps) {
  const wrapper = {
    props: reactiveComputed(() => {
      if (props.tag === "button") {
        return {
          type: "button",
          disabled: props.disabled,
        };
      }
      return {};
    }),
  };

  const showValid = computed(() => props.valid && props.showValidState);

  return {
    wrapper,
    tag: toRef(() => props.tag),
    disabled: toRef(() => props.disabled),
    valid: showValid,
    color: toRef(() => props.color),
    size: toRef(() => props.size),
  };
}

export type { UseInputWrapperAtomProps, UseInputWrapperAtomScoped };
export { props, scoped, use };
